import React from 'react';
import { CustomerSupportLink } from '../buttons';
import styles from './ContactUsFooter.module.scss';
import { Trans } from 'react-i18next';

export const ContactUsFooter = () => {
	return (
		<p className={styles.Text}>
			<Trans i18nKey='checkout.contact_us_footer' components={[<CustomerSupportLink key='customer-support-link' />]} />
		</p>
	);
};
